import React, { useState } from "react";
import axios from "axios";
import Topbar from "../pages/Topbar";

export default function ProjectPredictionPage() {
  const [formData, setFormData] = useState({
    title: "",
    count: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePredict = async () => {
    try {
      const response = await axios.post("http://localhost:4037/api/predict", formData);
      alert("Prediction result: " + response.data.result);
    } catch (error) {
      console.error("Prediction failed:", error);
      alert("Prediction failed");
    }
  };

  return (
    
    <div className="container d-flex justify-content-center align-items-center">
     
      <div className="col-12 col-sm-10 col-md-8 col-lg-6">
        <h4 className="text-start mb-4">Project Prediction Details</h4>

        <form >
            <div className="border p-5 rounded-5">
         <div className="row mb-3 align-items-center">
            <label className="col-sm-4 col-form-label">Project Title</label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter project title"
              />
            </div>
          </div>

          <div className="row mb-3 align-items-center">
            <label className="col-sm-4 col-form-label">Total Number of Count</label>
            <div className="col-sm-8">
              <input
                type="number"
                className="form-control"
                name="count"
                value={formData.count}
                onChange={handleChange}
                placeholder="Enter total count"
              />
            </div>
          </div>

          <div className="row mb-4 align-items-start">
            <label className="col-sm-4 col-form-label">Project Description</label>
            <div className="col-sm-8">
              <textarea
                className="form-control"
                name="description"
                rows="4"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter project description"
              ></textarea>
            </div>
          </div>
            </div>

          <div className="text-center mt-3">
            <button type="button" className="custom-btn bg-light text-black border px-4 w-50" onClick={handlePredict}>
              Predict
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
